import { toFolder } from '../mappers/folder';
export function parseFolders(settings, res) {
  res.data = (res.data.data || []).map(function (data) {
    return toFolder(data, settings);
  });
  return res;
}